(function () {
    'use strict';

    angular
        .module('app.score-detail')
        .config(configRoutes);

    configRoutes.$inject = ['$stateProvider', 'scoreDetailResolver'];
    function configRoutes($stateProvider, scoreDetailResolver) {
        // 173921115
        $stateProvider.state('score-detail', {
            url: '/score-detail/:scoreId',
            component: 'sc3ScoreDetail',
            resolve: scoreDetailResolver
        });
    }
})();
